import { useQuery } from '@tanstack/react-query';

import { getEmployee } from '~/services/BusinessTraveller/BusinessTravellerService';

export const employeeQueryKeys = {
  all: ['employee'] as const,
  byCustomerId: (customerId: string) => [...employeeQueryKeys.all, 'by-customer', customerId] as const,
};

export function useGetEmployee(customerId: string, enabled = true) {
  return useQuery({
    queryKey: employeeQueryKeys.byCustomerId(customerId),
    queryFn: () => getEmployee(customerId),
    enabled: enabled && !!customerId,
  });
}
